module.exports = __webpack_public_path__ + "6144.2d1a74dbf8da7d510203b3624da2a8a2.cache.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/anim/6144.png
// module id = 125
// module chunks = 0